var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeclineIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.577,
    height: 50.576,
    viewBox: "0 0 50.577 50.576",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    transform: "translate(-599.001 -1378.772) rotate(45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    transform: "translate(-12.021 6.364)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_23",
    "data-name": "Line 23",
    y2: 57.526,
    transform: "translate(1446.281 516.255)",
    fill: "none",
    stroke: "#1d3586",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_24",
    "data-name": "Line 24",
    x1: 57.526,
    transform: "translate(1417.518 545.018)",
    fill: "none",
    stroke: "#1d3586",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeclineIcon);
export default __webpack_public_path__ + "static/media/declineIcon.88abb63cd9641907b3f9c20b4f1c57c1.svg";
export { ForwardRef as ReactComponent };